import MuiSkeleton, {SkeletonProps} from '@mui/material/Skeleton';
import {styled} from '@mui/material/styles';

import {shouldNotForwardProp} from 'utils/styled';

type SkeletonItemProps = SkeletonProps & {inline?: boolean; maxWidth?: number};

const SSkeleton = styled(
  MuiSkeleton,
  shouldNotForwardProp('inline', 'maxWidth', 'color')
)<{
  inline?: boolean;
  maxWidth?: number;
  color?: string;
}>(({inline, maxWidth, color}) => ({
  display: inline ? 'inline-block' : undefined,
  maxWidth: maxWidth ?? '100%',
  backgroundColor: color,
}));

export const Skeleton = (props: SkeletonItemProps) => <SSkeleton {...props} />;
